module.exports = __webpack_public_path__ + "img/bell-ringing-03.38a04e93.svg";